import { render } from "./Home.vue?vue&type=template&id=22d6bc4c&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=22d6bc4c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-22d6bc4c"

export default script